// ### LoginPopup
//
// Watches Adobe's popup-login-instead-of-iframe window.

'use strict';

var App = require('./app');
var _logger = require('./logger');
var SimpleEmitter = require('./emitter');
var WindowWatcher = require('./windowwatcher');
var Dom = require('./dom');


var loginPopup = new WindowWatcher(App.ADOBE_IFRAME_NAME);

function onOpened() {
	/* jshint validthis:true */

	_logger.log('LoginPopup - onOpened');

	if (!loginPopup.window) {
		_logger.warn('Pop-up blocker may have prevented the login window from opening.');
		return;
	}

	loginPopup.focus();

	this.emit('opened');
}

function onClosed() {
	/* jshint validthis:true */

	_logger.log('LoginPopup - onClosed');

	this.emit('closed');
}

function open(mvpd, options, origin) {
	_logger.log('LoginPopup - open');

	if (loginPopup.isOpened()) {
		return;
	}

	// determine dimensions to center popup in front of content window
	var basicPopupWidth = 1000;
	var basicPopupHeight = 600;

	var viewportWidth = Dom.viewportWidth();
	var viewportHeight = Dom.viewportHeight();

	var iframeWidth = mvpd.iFrameWidth;
	var iframeHeight = mvpd.iFrameHeight;

	var defaultPopupWidth = Math.min( basicPopupWidth, (viewportWidth || basicPopupWidth), (screen.availWidth || basicPopupWidth) );
	var defaultPopupHeight = Math.min( basicPopupHeight, (viewportHeight || basicPopupHeight), (screen.availHeight || basicPopupHeight) );

	var popupWidth  = options && options.width  || mvpd.popupWidth  || iframeWidth  || defaultPopupWidth;
	var popupHeight = options && options.height || mvpd.popupHeight || iframeHeight || defaultPopupHeight;

	var popupLeft = (window.screenX || window.screenLeft || 0) + Math.max(25, Math.round((viewportWidth - popupWidth) / 2));
	var popupTop = (window.screenY || window.screenTop || 0) + Math.max(25, Math.round((viewportHeight - popupHeight) / 2));

	var windowOptions = [
		'width=' + popupWidth,
		'height=' + popupHeight,
		'left=' + popupLeft,
		'top=' + popupTop
	];

	loginPopup.open(origin, windowOptions.join(','));
}

function close() {
	_logger.log('LoginPopup - close');

	loginPopup.close();
}

function isOpened() {
	return loginPopup.isOpened();
}

function setSrc(url) {
	return loginPopup.setSrc(url);
}

var emitter = SimpleEmitter.mixin({
	isOpened : isOpened,
	setSrc : setSrc,
	open : open,
	close : close
});

loginPopup.on('opened', onOpened, emitter);
loginPopup.on('closed', onClosed, emitter);


module.exports = emitter;
